











import { Component, Prop, Vue } from 'vue-property-decorator';

import { EntityLocation, Product, Sensor, Site, Transceiver, Vat } from '@/api';
import { vatsListFields } from './models/vats-list-fields';

@Component({})
export default class MilkVatsOverview extends Vue {
	@Prop({ required: true, type: Array })
	public readonly vats!: Vat &
		{
			transceiver: Transceiver | null;
			entitylocation: EntityLocation | null;
		}[];

	@Prop({ required: true, type: Object })
	public readonly product!: Product & {
		site: Site | null;
		transceivers: Transceiver & { sensors: Sensor[] }[];
	};

	public get vatFields() {
		return vatsListFields;
	}

	public onVatClicked(_vat: Vat, index: number): void {
		this.$emit('vatClicked', index);
	}
}
